// extracted by mini-css-extract-plugin
export default {"AdSlotOffsite":"bgz_a bhy_bi"};